import React, { Component } from "react";
import { connect } from "react-redux";
import {
    getActivities,
    getClock,
    getRecentClocks,
    getWarehouses,
    isClockedIn,
    isLoading
} from "../../reducer";
import { clockIn, clockOut, get as loadClock } from "../../reducer/actions";
import { Button, Container, Form, Grid, Header, Icon, Segment } from "semantic-ui-react";
import {getUser} from "../../../../reducer";
import RecentClockList from "../../components/RecentClockList";
import DayOverview from "../../components/DayOverview";
import { Translate } from "react-localize-redux";
import moment from "moment";
import WarehouseSelect from "../../components/WarehouseSelect";
import ActivitySelect from "../../components/ActivitySelect";


class Clock extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activity_id: null,
            warehouse_id: null,
            changing: false
        }
    }

    componentWillMount() {

        this.props.loadClock().then(() => {
            let warehouse_id = null;
            let activity_id = null;
            if (this.props.warehouses !== null && typeof this.props.warehouses !== 'undefined') {
                if (this.getLastWarehouse()) {
                    warehouse_id = this.getLastWarehouse().id;
                } else {
                    warehouse_id = this.props.warehouses[0].id;
                }
            }
            if (this.props.activities !== null && typeof this.props.activities !== 'undefined') {
                if (this.getLastActivity()) {
                    activity_id = this.getLastActivity().id;
                } else {
                    activity_id = this.props.activities[0].id;
                }
            }
            this.setState({warehouse_id, activity_id});
        });
    }

    handleActivityChange(value) {
        this.setState({activity_id: value});
    }

    handleWarehouseChange(value) {
        this.setState({warehouse_id: value});
    }

    handleClockIn() {
        this.props.clockIn(this.state);
    }

    handleActiveActivityChange(){
        let warehouse_id = Number.parseInt(this.getCurrentWarehouse().id,10);
        let activity_id =  Number.parseInt(this.state.activity_id,10);

        this.setState({changing: true});

        this.props.clockOut().then(()=>{this.props.clockIn({
            warehouse_id,
            activity_id
        })}).then(()=>{this.setState({changing: false});});

    }

    prepareActivities() {
        if (this.props.activities === null || typeof this.props.activities === 'undefined') {
            return [];
        }
        return this.props.activities.map((activity) => (
            {key: activity.id, value: activity.id, text: activity.displayName}
        ));

    }

    prepareWarehouses() {
        if (this.props.warehouses === null || typeof this.props.warehouses === 'undefined') {
            return [];
        }
        return this.props.warehouses.filter((warehouse) => warehouse.active === 1)
            .map((warehouse) => (
            {key: warehouse.id, value: warehouse.id, text: warehouse.name}
        ));
    }


    render() {

        return (
            <Translate>
                {({translate}) =>
                    <Container text style={{padding: '1em 1em'}}>
                        <Header as='h2' icon textAlign='center'>
                            <Icon name='clock' circular/>
                        </Header>
                        <Grid
                            textAlign='center'
                            style={{height: '100%'}}
                            verticalAlign='middle'
                        >
                            <Grid.Column width={14}>
                                {this.props.clockedIn ?
                                    <div>
                                        <Header as='h2' color='teal' textAlign='center'>
                                            {"Arbeitszeiterfassung"} - {this.props.user.name}
                                        </Header>
                                        <Segment stacked>
                                            {translate('clock.currentActivity')}: {this.getCurrentActivity().displayName}
                                            <br/>
                                            {translate('clock.currentWarehouse')}: {this.getCurrentWarehouse().name}
                                            <br/>
                                            {translate('clock.clockedIn')} Aktivität: {moment(this.props.clock.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm - DD.MM.YYYY ')}
                                            <br/>
                                            {translate('clock.clockedIn')} Tag: {moment(this.getStartOfDay(), 'YYYY-MM-DD HH:mm:ss').format('HH:mm - DD.MM.YYYY ')}
                                            <br/>
                                            {"Arbeitszeit heute total: " + this.getTotalWorktimeToday() + " h"}
                                        </Segment>

                                            <Form
                                                loading={this.props.isLoading || this.state.changing}
                                                size='large'
                                                onSubmit={this.handleActiveActivityChange.bind(this)}>
                                                <Segment stacked>
                                                    <ActivitySelect
                                                        value={this.state.activity_id}
                                                        onChange={(value) => this.handleActivityChange(value)}
                                                        clock={true}
                                                    />
                                                    <Button disabled={this.props.isLoading || this.state.activity_id === this.getCurrentActivity().id}
                                                            loading={this.props.isLoading}
                                                            color='teal' fluid size='large'>Aktivität
                                                        ändern</Button>
                                                </Segment>
                                            </Form>
                                        <Button onClick={() => {
                                            this.props.clockOut()
                                        }} disabled={this.props.isLoading} loading={this.props.isLoading} color='red'
                                                fluid size='large'>{translate('clock.clockOut')}</Button>
                                    </div>
                                    :
                                    <div>

                                        <Header as='h2' color='teal' textAlign='center'>
                                            {translate('clock.clockIn')}  - {this.props.user.name}
                                        </Header>
                                        <Form loading={this.props.isLoading || this.state.changing} size='large'
                                              onSubmit={this.handleClockIn.bind(this)}>
                                            <Segment stacked>
                                                <ActivitySelect
                                                    value={this.state.activity_id}
                                                    onChange={(value) => this.handleActivityChange(value)}
                                                    clock={true}
                                                />
                                                <WarehouseSelect
                                                    value={this.state.warehouse_id}
                                                    onChange={(value) => this.handleWarehouseChange(value)}
                                                />
                                                <Button disabled={this.props.isLoading || this.state.changing} loading={this.props.isLoading || this.state.changing}
                                                        color='teal' fluid size='large'>{translate('clock.clockIn')}</Button>
                                            </Segment>
                                        </Form>

                                    </div>
                                }
                                <DayOverview/>
                                <RecentClockList/>
                            </Grid.Column>
                        </Grid>
                    </Container>
                }
            </Translate>
        )

    }

    getTotalWorktimeToday(){
        return this.props.clockedIn ?
            Math.round(this.props.recentClocks.reduce((a, b) => {
                return a + Math.round(Math.abs(Date.parse(b.start) - Date.parse(b.end)) / 36e3)
            }, 0) + Math.round(Math.abs(Date.parse(this.props.clock.start) - Date.parse(moment()
                .format('YYYY-MM-DD HH:mm:ss'))) / 36e3)) / 100
            :
            this.props.recentClocks.reduce((a, b) => {
                return a + Math.round(Math.abs(Date.parse(b.start) - Date.parse(b.end)) / 36e3)
            }, 0) / 100;
    }

    getStartOfDay(){
        if (typeof this.props.recentClocks === 'undefined') {
            return this.moment(this.props.clock.start);
        }
        return this.props.recentClocks.filter((clock)=>moment().startOf('day').diff(moment(clock.start)) < 0 ).reduce((a,b)=>{
            if(a.diff(moment(b.start)) > 0){
                return moment(b.start)
            }
            return a;
        },moment(this.props.clock.start));
    }

    getLastActivity() {
        if (typeof this.props.recentClocks === 'undefined' || this.props.recentClocks === null || this.props.recentClocks.length === 0) {
            return false;
        }
        return this.getActivityFromClock(this.props.recentClocks[0]);
    }

    getLastWarehouse() {
        if (typeof this.props.recentClocks === 'undefined' || this.props.recentClocks === null || this.props.recentClocks.length === 0) {
            return false;
        }
        return this.getWarehouseFromClock(this.props.recentClocks[0]);
    }

    getCurrentActivity() {
        return this.getActivityFromClock(this.props.clock);
    }

    getActivityFromClock(clock) {
        if (typeof clock === 'undefined' || clock == null) {
            return false;
        }

        if (typeof this.props.activities === 'undefined' || this.props.activities == null) {
            return false;
        }

        const activity = this.props.activities.find((element) => (element.id === clock.activity_id));

        if (typeof activity.displayName === 'undefined' || activity.displayName === null) {
            return false;
        }

        return activity;
    }

    getCurrentWarehouse() {
        return this.getWarehouseFromClock(this.props.clock);
    }

    getWarehouseFromClock(clock) {
        if (typeof clock === 'undefined' || clock == null) {
            return false;
        }

        if (typeof this.props.warehouses === 'undefined' || this.props.warehouses == null) {
            return false;
        }

        const warehouse = this.props.warehouses.find((element) => (element.id === clock.warehouse_id));

        if (typeof warehouse.name === 'undefined' || warehouse.name === null) {
            return false;
        }

        return warehouse;
    }
}


const mapStateToProps = state => ({
    clock: getClock(state),
    clockedIn: isClockedIn(state),
    warehouses: getWarehouses(state),
    activities: getActivities(state),
    isLoading: isLoading(state),
    recentClocks: getRecentClocks(state),
    user: getUser(state)
});


function mergeProps(stateProps, dispatchProps, ownProps) {

    return {
        ...dispatchProps,
        ...stateProps,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch) => {
    return ({
        loadClock: () => (dispatch(loadClock())),
        clockIn: (body) => (dispatch(clockIn(body))),
        clockOut: () => (dispatch(clockOut())),
    })
}


// No need to connect()!
export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Clock)



// WEBPACK FOOTER //
// ./src/scenes/Clock/scenes/Clock/index.js